import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  getOrdenTaller, updateOrdenTaller, updateEstadoTaller, guardarItemsTaller,
  consumirRepuestosTaller, enlazarFacturaTaller, createFactura, getProductos,
  createRecordatorioTaller,
} from '../services/api';

const ESTADOS = [
  ['recepcion','Recepción'], ['diagnostico','Diagnóstico'], ['cotizacion','Cotización'],
  ['aprobada','Aprobada'], ['en_proceso','En proceso'], ['control','Control'],
  ['lista','Lista'], ['entregada','Entregada'], ['cancelada','Cancelada'],
];
const SECCIONES = ['General','Motor','Frenos','Suspensión','Transmisión','Eléctrico','Refrigeración','Carrocería','Llantas'];
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const nuevoItem = () => ({ _k: Math.random().toString(36).slice(2), tipo:'repuesto', seccion:'General', producto_id:null, descripcion:'', cantidad:1, precio_unitario:0, iva_pct:19, aprobado:false, consumido:false });

export default function DetalleOrdenTaller() {
  const { id } = useParams();
  const nav = useNavigate();
  const [o, setO] = useState(null);
  const [items, setItems] = useState([]);
  const [cab, setCab] = useState({ motivo:'', diagnostico:'', observaciones:'', km_entrada:'', km_salida:'' });
  const [saving, setSaving] = useState(false);
  const [busy, setBusy] = useState('');
  const [rec, setRec] = useState({ tipo:'', proximo_km:'', proxima_fecha:'' });

  const cargar = useCallback(() => {
    getOrdenTaller(id).then(r => {
      const d = r.data;
      setO(d);
      setItems((d.items || []).map(it => ({ ...it, _k: it.id })));
      setCab({ motivo:d.motivo||'', diagnostico:d.diagnostico||'', observaciones:d.observaciones||'',
               km_entrada:d.km_entrada ?? '', km_salida:d.km_salida ?? '' });
    });
  }, [id]);
  useEffect(() => { cargar(); }, [cargar]);

  const setItem = (k, patch) => setItems(items.map(it => it._k === k ? { ...it, ...patch } : it));
  const delItem = (k) => setItems(items.filter(it => it._k !== k));
  const addItem = () => setItems([...items, nuevoItem()]);
  const aprobarSeccion = (sec, val) => setItems(items.map(it => (it.seccion || 'General') === sec ? { ...it, aprobado: val } : it));

  const lineTotal = (it) => {
    const base = (parseFloat(it.cantidad)||0) * (parseFloat(it.precio_unitario)||0);
    return base + base * (parseFloat(it.iva_pct)||0)/100;
  };
  const totCotizado = items.reduce((a, it) => a + lineTotal(it), 0);
  const totAprobado = items.filter(it => it.aprobado).reduce((a, it) => a + lineTotal(it), 0);

  const guardar = async () => {
    setSaving(true);
    try {
      await updateOrdenTaller(id, {
        ...cab,
        km_entrada: cab.km_entrada === '' ? null : cab.km_entrada,
        km_salida:  cab.km_salida === ''  ? null : cab.km_salida,
      });
      await guardarItemsTaller(id, items.map(it => ({
        id: (typeof it.id === 'string') ? it.id : undefined,
        tipo: it.tipo, seccion: it.seccion, producto_id: it.producto_id,
        descripcion: it.descripcion, cantidad: it.cantidad, precio_unitario: it.precio_unitario,
        iva_pct: it.iva_pct, aprobado: it.aprobado,
      })));
      await cargar();
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  const cambiarEstado = (estado) => updateEstadoTaller(id, estado).then(cargar);

  const consumir = async () => {
    if (!window.confirm('¿Descontar del inventario los repuestos aprobados de esta orden?')) return;
    setBusy('consumir');
    try { await guardar(); const r = await consumirRepuestosTaller(id); alert(r.data.mensaje || `Repuestos descontados: ${r.data.consumidos}`); await cargar(); }
    catch (e) { alert(e.response?.data?.error || 'Error al descontar'); }
    finally { setBusy(''); }
  };

  const facturar = async () => {
    if (!o.cliente_id) return alert('La orden no tiene cliente asignado. Asígnalo en el vehículo.');
    const aprobados = items.filter(it => it.aprobado);
    if (!aprobados.length) return alert('No hay ítems aprobados para facturar');
    if (!window.confirm(`Generar factura por ${fmt(totAprobado)} con los ítems aprobados?`)) return;
    setBusy('facturar');
    try {
      await guardar();
      const payload = {
        cliente_id: o.cliente_id,
        notas: `Orden de servicio ${o.numero}${o.placa ? ' · '+o.placa : ''}`,
        items: aprobados.map(it => ({ descripcion: it.descripcion, cantidad: it.cantidad, precio_unitario: it.precio_unitario, iva_pct: it.iva_pct, unidad:'und' })),
      };
      const r = await createFactura(payload);
      await enlazarFacturaTaller(id, r.data.id);
      nav(`/facturacion/${r.data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Error al facturar'); setBusy(''); }
  };

  const agregarRecordatorio = async () => {
    if (!rec.tipo) return alert('Indica el tipo de mantenimiento');
    try {
      await createRecordatorioTaller({ vehiculo_id: o.vehiculo_id, orden_id: id, tipo: rec.tipo,
        proximo_km: rec.proximo_km || null, proxima_fecha: rec.proxima_fecha || null });
      setRec({ tipo:'', proximo_km:'', proxima_fecha:'' });
      alert('Recordatorio agregado al vehículo');
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
  };

  if (!o) return <div style={{ color:'#64748b', padding:20 }}>Cargando…</div>;

  // Agrupa ítems por sección para mostrar y aprobar por sección.
  const secciones = [...new Set(items.map(it => it.seccion || 'General'))];

  return (
    <div>
      <div style={s.pageHeader}>
        <div>
          <button style={s.back} onClick={() => nav('/taller')}>← Tablero</button>
          <h1 style={s.h1}>{o.numero} <span style={s.placaBig}>{o.placa || '—'}</span></h1>
          <p style={s.sub}>{[o.marca, o.linea, o.modelo_anio].filter(Boolean).join(' ')} · {o.cliente_nombre || 'Sin cliente'}
            {o.factura_id ? <span style={s.facOk}> · Facturada</span> : null}</p>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', justifyContent:'flex-end' }}>
          <select style={s.estadoSel} value={o.estado} onChange={e => cambiarEstado(e.target.value)}>
            {ESTADOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <button style={s.btnSecondary} onClick={consumir} disabled={busy==='consumir'}>{busy==='consumir'?'…':'Descontar repuestos'}</button>
          <button style={s.btnPrimary} onClick={facturar} disabled={!!busy || !!o.factura_id}>{busy==='facturar'?'…': o.factura_id ? 'Ya facturada' : 'Facturar aprobados'}</button>
        </div>
      </div>

      {/* Datos de la orden */}
      <div style={s.card}>
        <div style={s.row3}>
          <div style={s.field}><label style={s.label}>Km de entrada</label>
            <input style={s.input} type="number" value={cab.km_entrada} onChange={e => setCab({ ...cab, km_entrada:e.target.value })} /></div>
          <div style={s.field}><label style={s.label}>Km de salida</label>
            <input style={s.input} type="number" value={cab.km_salida} onChange={e => setCab({ ...cab, km_salida:e.target.value })} /></div>
          <div style={s.field}><label style={s.label}>Entrega estimada</label>
            <input style={s.input} type="date" value={o.fecha_entrega_estimada ? o.fecha_entrega_estimada.slice(0,10) : ''} readOnly /></div>
        </div>
        <div style={s.field}><label style={s.label}>Motivo / falla reportada</label>
          <textarea style={{ ...s.input, minHeight:48, resize:'vertical', height:'auto', padding:'8px 12px' }} value={cab.motivo} onChange={e => setCab({ ...cab, motivo:e.target.value })} /></div>
        <div style={s.row2}>
          <div style={s.field}><label style={s.label}>Diagnóstico</label>
            <textarea style={{ ...s.input, minHeight:48, resize:'vertical', height:'auto', padding:'8px 12px' }} value={cab.diagnostico} onChange={e => setCab({ ...cab, diagnostico:e.target.value })} /></div>
          <div style={s.field}><label style={s.label}>Observaciones</label>
            <textarea style={{ ...s.input, minHeight:48, resize:'vertical', height:'auto', padding:'8px 12px' }} value={cab.observaciones} onChange={e => setCab({ ...cab, observaciones:e.target.value })} /></div>
        </div>
      </div>

      {/* Ítems (cotización por sección) */}
      <div style={{ ...s.card, marginTop:14 }}>
        <div style={s.cardHead}>
          <h3 style={s.cardTitle}>Trabajos y repuestos</h3>
          <button style={s.addBtn} onClick={addItem}>+ Agregar ítem</button>
        </div>

        {secciones.map(sec => {
          const its = items.filter(it => (it.seccion || 'General') === sec);
          const todoAprob = its.length > 0 && its.every(it => it.aprobado);
          return (
            <div key={sec} style={s.secBlock}>
              <div style={s.secHead}>
                <span style={s.secName}>{sec}</span>
                <button style={s.secAprobar} onClick={() => aprobarSeccion(sec, !todoAprob)}>
                  {todoAprob ? 'Quitar aprobación' : 'Aprobar sección'}
                </button>
              </div>
              {its.map(it => (
                <ItemRow key={it._k} it={it} onChange={(p) => setItem(it._k, p)} onDelete={() => delItem(it._k)} lineTotal={lineTotal(it)} />
              ))}
            </div>
          );
        })}
        {items.length === 0 && <div style={s.empty}>Sin ítems. Agrega repuestos y mano de obra; el cliente aprueba qué se hace.</div>}

        <div style={s.totales}>
          <div><span style={s.totLbl}>Cotizado</span> <span style={s.totVal}>{fmt(totCotizado)}</span></div>
          <div><span style={s.totLbl}>Aprobado</span> <span style={{ ...s.totVal, color:'#10b981' }}>{fmt(totAprobado)}</span></div>
        </div>
      </div>

      {/* Recordatorio de mantenimiento */}
      <div style={{ ...s.card, marginTop:14 }}>
        <div style={s.cardHead}><h3 style={s.cardTitle}>Recordatorio de mantenimiento</h3></div>
        <div style={s.row3}>
          <div style={s.field}><label style={s.label}>Tipo</label>
            <input style={s.input} list="rec-tipos" value={rec.tipo} onChange={e => setRec({ ...rec, tipo:e.target.value })} placeholder="Cambio de aceite" />
            <datalist id="rec-tipos">{['Cambio de aceite','Revisión general','Frenos','Sincronización','Llantas','Batería'].map(t => <option key={t} value={t} />)}</datalist></div>
          <div style={s.field}><label style={s.label}>Próximo a los (km)</label>
            <input style={s.input} type="number" value={rec.proximo_km} onChange={e => setRec({ ...rec, proximo_km:e.target.value })} /></div>
          <div style={s.field}><label style={s.label}>o en la fecha</label>
            <input style={s.input} type="date" value={rec.proxima_fecha} onChange={e => setRec({ ...rec, proxima_fecha:e.target.value })} /></div>
        </div>
        <button style={s.btnSecondary} onClick={agregarRecordatorio}>Agregar recordatorio</button>
      </div>

      <div style={s.footerBar}>
        <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={guardar} disabled={saving}>{saving ? 'Guardando…' : 'Guardar cambios'}</button>
      </div>
    </div>
  );
}

// Fila de ítem con buscador de producto embebido.
function ItemRow({ it, onChange, onDelete, lineTotal }) {
  const [q, setQ] = useState('');
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => { getProductos(q).then(r => setRes((r.data || []).slice(0, 6))).catch(() => setRes([])); }, 200);
    return () => clearTimeout(t);
  }, [q, open]);
  const pick = (p) => {
    onChange({ producto_id: p.id, descripcion: p.nombre, precio_unitario: p.precio_unitario || 0, iva_pct: p.iva_pct ?? 19 });
    setOpen(false); setQ('');
  };
  return (
    <div style={ir.row}>
      <input type="checkbox" checked={!!it.aprobado} onChange={e => onChange({ aprobado: e.target.checked })} title="Aprobado por el cliente" style={{ marginTop:8 }} />
      <select style={{ ...ir.cell, width:96 }} value={it.tipo} onChange={e => onChange({ tipo: e.target.value })}>
        <option value="repuesto">Repuesto</option>
        <option value="mano_obra">Mano de obra</option>
      </select>
      <select style={{ ...ir.cell, width:110 }} value={it.seccion || 'General'} onChange={e => onChange({ seccion: e.target.value })}>
        {SECCIONES.map(x => <option key={x} value={x}>{x}</option>)}
      </select>
      <div style={{ flex:1, position:'relative', minWidth:160 }}>
        <input style={{ ...ir.cell, width:'100%' }} value={it.descripcion} placeholder={it.tipo==='repuesto' ? 'Buscar repuesto o escribir…' : 'Describir el trabajo…'}
          onChange={e => { onChange({ descripcion: e.target.value }); if (it.tipo==='repuesto') { setQ(e.target.value); setOpen(true); } }}
          onFocus={() => it.tipo==='repuesto' && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
        {it.producto_id ? <span style={ir.linked} title="Vinculado a producto (descuenta inventario)">●</span> : null}
        {open && res.length > 0 && (
          <div style={ir.drop}>
            {res.map(p => <div key={p.id} style={ir.opt} onMouseDown={() => pick(p)}>{p.nombre} <span style={{ color:'#64748b' }}>{fmt(p.precio_unitario)}</span></div>)}
          </div>
        )}
      </div>
      <input style={{ ...ir.cell, width:56, textAlign:'right' }} type="number" value={it.cantidad} onChange={e => onChange({ cantidad: e.target.value })} />
      <input style={{ ...ir.cell, width:100, textAlign:'right' }} type="number" value={it.precio_unitario} onChange={e => onChange({ precio_unitario: e.target.value, producto_id: null })} />
      <select style={{ ...ir.cell, width:62 }} value={it.iva_pct} onChange={e => onChange({ iva_pct: e.target.value })}>
        {[0,5,19].map(x => <option key={x} value={x}>{x}%</option>)}
      </select>
      <span style={ir.total}>{fmt(lineTotal)}</span>
      <button style={ir.del} onClick={onDelete} title="Quitar">✕</button>
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10, gap:12, flexWrap:'wrap' },
  back:        { background:'transparent', border:'none', color:'#60a5fa', fontSize:13, cursor:'pointer', padding:0, marginBottom:4 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px', display:'flex', alignItems:'center', gap:10 },
  placaBig:    { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:6, padding:'2px 10px', fontSize:16, fontWeight:700, letterSpacing:1 },
  sub:         { color:'#64748b', fontSize:13, margin:0 },
  facOk:       { color:'#10b981', fontWeight:600 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'9px 18px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'9px 16px', fontSize:13, cursor:'pointer' },
  estadoSel:   { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'8px 12px', fontSize:13, cursor:'pointer' },
  card:        { background:'#1e293b', borderRadius:12, padding:16 },
  cardHead:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 },
  cardTitle:   { color:'#f1f5f9', fontSize:15, fontWeight:600, margin:0 },
  addBtn:      { background:'#0f172a', border:'1px solid #334155', color:'#93c5fd', borderRadius:8, padding:'6px 12px', fontSize:13, cursor:'pointer' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row3:        { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  secBlock:    { marginBottom:10 },
  secHead:     { display:'flex', alignItems:'center', gap:10, padding:'4px 0', borderBottom:'1px solid #243044', marginBottom:6 },
  secName:     { color:'#cbd5e1', fontSize:13, fontWeight:600 },
  secAprobar:  { marginLeft:'auto', background:'transparent', border:'1px solid #334155', color:'#93c5fd', borderRadius:6, padding:'2px 10px', fontSize:11, cursor:'pointer' },
  empty:       { color:'#475569', textAlign:'center', padding:'16px 0', fontSize:13 },
  totales:     { display:'flex', justifyContent:'flex-end', gap:28, borderTop:'1px solid #334155', paddingTop:12, marginTop:6 },
  totLbl:      { color:'#64748b', fontSize:12, marginRight:8 },
  totVal:      { color:'#f1f5f9', fontSize:16, fontWeight:700 },
  footerBar:   { display:'flex', justifyContent:'flex-end', marginTop:16 },
};
const ir = {
  row:    { display:'flex', gap:6, alignItems:'flex-start', marginBottom:6 },
  cell:   { height:32, padding:'0 8px', background:'#0f172a', border:'1px solid #334155', borderRadius:6, color:'#f1f5f9', fontSize:12, boxSizing:'border-box', outline:'none' },
  total:  { minWidth:90, textAlign:'right', color:'#e2e8f0', fontSize:12, paddingTop:8, fontWeight:600 },
  del:    { background:'transparent', border:'none', color:'#64748b', cursor:'pointer', fontSize:14, paddingTop:6 },
  linked: { position:'absolute', right:8, top:8, color:'#10b981', fontSize:10 },
  drop:   { position:'absolute', top:34, left:0, right:0, background:'#1e293b', border:'1px solid #334155', borderRadius:8, zIndex:20, maxHeight:180, overflowY:'auto' },
  opt:    { padding:'7px 10px', fontSize:12, color:'#cbd5e1', cursor:'pointer', borderBottom:'1px solid #243044' },
};
